const LoaderAbilityParams = ({ length = 1 }) => {
    return (
        <div className="loader_ability_params_cont">
            {Array.from({ length }).map((_, index) => (
                <div
                    key={index}
                    className="loader_ability_params_item"
                />
            ))}
        </div>
    );
};

export default LoaderAbilityParams;